import React, { useState, useEffect } from 'react';
import API from '../api/api';

function GeneralRevenues({ partnership }) {
  const [revenues, setRevenues] = useState([]);
  const [partners, setPartners] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [form, setForm] = useState({ amount:'', description:'', transfer_name:'', date:'', note:'' });
  const [customShares, setCustomShares] = useState({});
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const res = await API.get(`/general-revenues/${partnership.id}/`);
    setRevenues(res.data.revenues || []);
    setPartners(res.data.partners || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, [partnership.id]);

  const fmt = (n) => Number(n).toLocaleString('ar-SA', {useGrouping:false, minimumFractionDigits:2, maximumFractionDigits:2});

  const totalCustom = Object.values(customShares).reduce((a,b)=>a+(parseFloat(b)||0),0);

  const handleSave = async () => {
    if (!form.amount || !form.description) { alert('المبلغ والوصف مطلوبان'); return; }
    if (isCustom && Math.abs(totalCustom - parseFloat(form.amount)) > 0.01) {
      alert(`مجموع التوزيع المخصص (${fmt(totalCustom)}) لا يساوي المبلغ الكلي (${fmt(form.amount)})`);
      return;
    }
    await API.post(`/general-revenues/${partnership.id}/`, {
      action:'add', ...form, is_custom:isCustom,
      custom_shares: isCustom ? customShares : {}
    });
    setShowForm(false);
    setForm({ amount:'', description:'', transfer_name:'', date:'', note:'' });
    setCustomShares({});
    setIsCustom(false);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل تريد حذف هذا الإيراد؟')) return;
    await API.post(`/general-revenues/${partnership.id}/`, { action:'delete', id });
    load();
  };

  if (loading) return <div style={{textAlign:'center',padding:'50px'}}>جاري التحميل...</div>;

  return (
    <div style={{padding:'20px'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
        <h3 style={{margin:0,color:'#1e3a5f'}}>💰 الإيرادات العامة (بيع أصول وغيرها)</h3>
        <button onClick={()=>setShowForm(!showForm)} style={{padding:'8px 16px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontWeight:'bold'}}>
          + إيراد عام جديد
        </button>
      </div>

      <div style={{background:'#e8f4fd',padding:'12px',borderRadius:'8px',marginBottom:'20px',fontSize:'13px',color:'#1e3a5f'}}>
        💡 يُوزَّع هذا الإيراد على جميع الشركاء كرصيد دائن حسب نصيب كل شريك في الدورة
      </div>

      {showForm && (
        <div style={{background:'white',padding:'20px',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',marginBottom:'20px',border:'2px solid #27ae60'}}>
          <h4 style={{margin:'0 0 15px',color:'#27ae60'}}>إضافة إيراد عام</h4>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px'}}>
            <div>
              <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>المبلغ الكلي (ريال) *</label>
              <input type="number" value={form.amount} onChange={e=>setForm({...form,amount:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>وصف الإيراد *</label>
              <input value={form.description} onChange={e=>setForm({...form,description:e.target.value})}
                placeholder="مثال: بيع غطاس قديم"
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>اسم المحوّل (اختياري)</label>
              <input value={form.transfer_name} onChange={e=>setForm({...form,transfer_name:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>تاريخ التحويل (اختياري)</label>
              <input type="date" value={form.date} onChange={e=>setForm({...form,date:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
            </div>
            <div style={{gridColumn:'1/-1'}}>
              <label style={{fontSize:'13px',color:'#666',display:'block',marginBottom:'4px'}}>ملاحظة (اختياري)</label>
              <input value={form.note} onChange={e=>setForm({...form,note:e.target.value})}
                style={{width:'100%',padding:'8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'13px',boxSizing:'border-box'}}/>
            </div>
          </div>

          <div style={{marginBottom:'15px'}}>
            <label style={{display:'flex',alignItems:'center',gap:'8px',cursor:'pointer',fontSize:'13px',fontWeight:'bold',color:'#e67e22'}}>
              <input type="checkbox" checked={isCustom} onChange={e=>setIsCustom(e.target.checked)} />
              توزيع مخصص (تحديد نصيب كل شريك يدوياً)
            </label>
          </div>

          {isCustom && (
            <div style={{marginBottom:'15px',background:'#fff9f0',padding:'15px',borderRadius:'8px',border:'1px solid #e67e22'}}>
              <p style={{margin:'0 0 10px',fontSize:'13px',color:'#e67e22',fontWeight:'bold'}}>
                المبلغ الكلي: {fmt(form.amount||0)} | موزّع: {fmt(totalCustom)} | متبقي: {fmt((parseFloat(form.amount)||0)-totalCustom)}
              </p>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
                {partners.map(pp=>(
                  <div key={pp.id} style={{display:'flex',alignItems:'center',gap:'8px'}}>
                    <label style={{fontSize:'12px',color:'#333',minWidth:'120px'}}>{pp.name.substring(0,25)}</label>
                    <input type="number" value={customShares[pp.id]||''} 
                      onChange={e=>setCustomShares({...customShares,[pp.id]:e.target.value})}
                      placeholder="0"
                      style={{width:'100px',padding:'6px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px'}}/>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{display:'flex',gap:'10px'}}>
            <button onClick={handleSave} style={{padding:'9px 20px',background:'#27ae60',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',fontWeight:'bold'}}>
              حفظ الإيراد العام
            </button>
            <button onClick={()=>{setShowForm(false);setIsCustom(false);setCustomShares({});}} 
              style={{padding:'9px 20px',background:'#e74c3c',color:'white',border:'none',borderRadius:'6px',cursor:'pointer'}}>
              إلغاء
            </button>
          </div>
        </div>
      )}

      {revenues.length === 0 ? (
        <div style={{textAlign:'center',padding:'40px',color:'#888'}}>لا توجد إيرادات عامة بعد</div>
      ) : (
        <table style={{width:'100%',borderCollapse:'collapse',background:'white',borderRadius:'10px',overflow:'hidden',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <thead style={{position:'sticky',top:0,zIndex:10}}>
            <tr style={{background:'#1e3a5f',color:'white'}}>
              <th style={{padding:'12px',textAlign:'right',border:'1px solid #0d2137'}}>#</th>
              <th style={{padding:'12px',textAlign:'right',border:'1px solid #0d2137'}}>الوصف</th>
              <th style={{padding:'12px',textAlign:'center',border:'1px solid #0d2137'}}>المبلغ الكلي</th>
              <th style={{padding:'12px',textAlign:'center',border:'1px solid #0d2137'}}>التاريخ</th>
              <th style={{padding:'12px',textAlign:'center',border:'1px solid #0d2137'}}>نوع التوزيع</th>
              <th style={{padding:'12px',textAlign:'center',border:'1px solid #0d2137'}}>حذف</th>
            </tr>
          </thead>
          <tbody>
            {revenues.map((r,i)=>(
              <tr key={r.id} style={{borderBottom:'1px solid #eee',background:i%2===0?'#f9f9f9':'white'}}>
                <td style={{padding:'10px',border:'1px solid #eee'}}>{i+1}</td>
                <td style={{padding:'10px',border:'1px solid #eee',fontWeight:'bold'}}>{r.description}</td>
                <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center',color:'#27ae60',fontWeight:'bold'}}>{fmt(r.amount)} ر.س</td>
                <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center',color:'#666'}}>{r.date||'—'}</td>
                <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center'}}>
                  <span style={{background:r.is_custom?'#e67e22':'#3498db',color:'white',padding:'3px 8px',borderRadius:'10px',fontSize:'12px'}}>
                    {r.is_custom?'مخصص':'تلقائي'}
                  </span>
                </td>
                <td style={{padding:'10px',border:'1px solid #eee',textAlign:'center'}}>
                  <button onClick={()=>handleDelete(r.id)} style={{padding:'4px 10px',background:'#e74c3c',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'12px'}}>
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default GeneralRevenues;
